export default {

}



// WEBPACK FOOTER //
// ./src/store/modules/image_upload/mutations.js